module.exports = __webpack_public_path__ + "static/media/calendar.522311da.svg";